/**
 * 模組代碼: 1110-UI-01
 * 模組說明: 登入驗證功能頁面
 * @module modules/login/LoginPage
 */

// ----- import from npm modules -----
import {useNavigate} from 'react-router-dom';
import CryptoJS from 'crypto-js';

// ----- import base libraries -----
import {React, BaseComponent, connect} from '../../components/BaseComponent';
import PasswordInput from '../../components/PasswordInput';

// ----- import from local actions -----
import {login} from './../../redux/actions/AuthActions';
import {fetchUserPermissions} from './../../redux/actions/AccessActions';
import {showAlert} from 'web/utils/modalHelper';
import enumList from 'web/utils/enumList';

// ----- contents -----
const FIXED_SALT = process.env.REACT_APP_FIXED_SALT;
const CUSTOM_ALERT_CODE = [111008, 111009];

/**
 *
 */
class LoginPage extends BaseComponent {
  /**
   *
   */
  constructor(props) {
    super(props);
    this.state = {
      account: '',
      password: '',
      rememberAccount: false,
      alertMessage: '',
    };
    this.setAccount = this.setAccount.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setRememberAccount = this.setRememberAccount.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showAlert = this.showAlert.bind(this);
  }

  /**
   *
   */
  setAccount(account) {
    this.setState({account});
  }

  /**
   *
   */
  setPassword(password) {
    this.setState({password});
  }

  /**
   *
   */
  setRememberAccount(rememberAccount) {
    this.setState({rememberAccount});
  }

  /**
   *
   */
  showAlert(message) {
    this.setState({
      alertMessage: [null, undefined].includes(message) ? '' : message,
    });
  }

  /**
   *
   */
  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    this.setState({
      alertMessage: '',
    });

    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      this.showAlert('[111000] 帳號密碼不得為空, ');
      return;
    }
    form.classList.add('was-validated');

    // 建立 FormData 讀取表单的值
    const formData = new FormData(form);
    const account = formData.get('loginAccount');
    const password = formData.get('loginPassword');
    const rememberAccount = this.state.rememberAccount;

    // 將密碼加密
    const encryptedPassword = CryptoJS.SHA256(password + FIXED_SALT).toString();
    formData.set('loginPassword', encryptedPassword);

    // 如果選擇記住帳號，則將帳號存入 localStorage
    if (rememberAccount) {
      localStorage.setItem('account', account);
    } else {
      localStorage.removeItem('account');
    }

    this.props
      .onLogin(account, encryptedPassword, rememberAccount)
      .then(() => {
        const status = this.props.auth.status;
        if (status === 'rejected') {
          const error = `[${this.props.auth.statusCode}]  ${this.props.auth.error}`;
          this.showAlert(error);
          return;
        }

        // 取得使用者權限
        this.props.fetchUserPermissions().then(() => {
          // 如果登入成功，跳轉到 MainFrame 頁面
          this.props.navigate('/module');
        });
      })
      .catch((error) => {
        console.error('login error:', error);
      });
  }

  /**
   *
   */
  componentDidMount() {
    // 讀取 localStorage 記錄的帳號
    const account = localStorage.getItem('account');
    if (account !== null) {
      this.setState({account: account, rememberAccount: true});
    }
  }

  /**
   *
   */
  render() {
    return (
      <div className="m__wrap">
        <div className="header-container">
          <header className="c__header">
            <img className="img-fluid header-logo" src="/images/logo-CentryTrading_blk.svg" alt="世紀貿易股份有限公司" />
            <button
              className="btn btn-link header-menu"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNav"
              aria-controls="offcanvasNav"
            >
              <span className="material-symbols-outlined"> menu </span>
            </button>
          </header>
        </div>
        <div className="m__contents">
          <section id="login-container">
            <form className="needs-validation d-flex flex-column gap-3" id="loginForm" onSubmit={this.handleSubmit} noValidate>
              <h1 className="d-flex flex-column align-items-center justify-content-center">
                <div className="fs-4">AI智能派工系統</div>
              </h1>
              <div className="d-flex flex-column gap-3">
                <div>
                  <label htmlFor="loginAccount" className="form-label">
                    帳號
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="loginAccount"
                    name="loginAccount"
                    value={this.state.account}
                    onChange={(e) => this.setAccount(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="loginPassword" className="form-label">
                    密碼
                  </label>
                  <PasswordInput
                    id="loginPassword"
                    name="loginPassword"
                    value={this.state.password}
                    onChange={(e) => this.setPassword(e.target.value)}
                    validateType="login"
                    placeholder=""
                    defaultMassage="密碼不得為空白"
                    size=""
                    required
                  />
                </div>
                <div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="loginKeepAccount"
                      name="loginKeepAccount"
                      checked={this.state.rememberAccount}
                      onChange={(e) => this.setRememberAccount(e.target.checked)}
                    />
                    <label className="form-check-label form-label" htmlFor="loginKeepAccount">
                      記住我的帳號
                    </label>
                  </div>
                </div>
              </div>
              <button type="submit" className="btn btn-primary" id="signInButton">
                登入
              </button>
              <div
                className={[
                  'global-invalid-feedback',
                  'global-invalid-feedback--login',
                  CUSTOM_ALERT_CODE.includes(this.props.auth.statusCode) ? 'custom-invalid-feedback' : undefined
                ].filter((value) => value).join(' ')}
                style={{
                  display: this.state.alertMessage ? 'block' : 'none',
                }}
              >{this.state.alertMessage}{CUSTOM_ALERT_CODE.includes(this.props.auth.statusCode) ? '' : ', '}</div>
            </form>
          </section>
        </div>
        <div className="footer-container">
          <footer className="c__footer">COPYRIGHT © CENTURY TRADING CO.,LTD. ALL RIGHTS RESERVED</footer>
        </div>
      </div>
    );
  }
}

/**
 *
 */
function mapStateToProps(state) {
  return {
    auth: state.auth,
    account: state.account,
    password: state.password,
  };
}

/**
 *
 */
function mapDispatchToProps(dispatch) {
  return {
    onLogin: (account, password, persist) => {
      return dispatch(login({account, password, persist}));
    },
    fetchUserPermissions: () => {
      return dispatch(fetchUserPermissions()).then(() => {
        return Promise.resolve();
      });
    },
  };
}

const ConnectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPage);

/**
 *
 */
export default function Login(props) {
  const navigate = useNavigate();
  return <ConnectedLoginPage {...props} navigate={navigate} />;
}
